<div>
  <mat-card>
    <div fxLayout.xs="column wrap" fxLayout.sm="column wrap" fxFlex="50" fxLayout.md="row wrap"
    fxLayoutAlign="space-between center" class="Products__header">
      <div fxLayout="row wrap" fxFlex="100" >
        <div fxFlex.sm="100" fxFlex.xs="100" fxFlexAlign.gt-md="center">
          <mat-form-field appearance="outline" fxFlex.lt-md="100" style="margin-right: 10px;">
            <input matInput (keyup)="onSearch($event)" [(ngModel)]="searchInput" autocomplete="off" class="position-relative"
              placeholder="{{ 'form.search' | translate}}">
            <button *ngIf="searchInput" matSuffix mat-icon-button aria-label="Clear" (click)="onClearSearch()" type="button">
              <mat-icon>close</mat-icon>
            </button>   
          </mat-form-field>
          <mat-error *ngIf="searchInput.length == 1 || searchInput.length == 2">
            <small>{{ "error.search" | translate }}</small>
          </mat-error>
        </div>
        <!-- <mat-form-field appearance="outline" floatLabel="always" fxFlex.sm="100" fxFlex.xs="100" *ngIf="filterLocations && show_location">
          <mat-label>{{ "filterByLocations" | translate }}</mat-label>
            <mat-select [(ngModel)]="selectedLocation" name="selectLocation" (selectionChange)="onSelectionChange($event)" multiple>
              <mat-option [value]="0">{{ "all" | translate }}</mat-option>
              <mat-option *ngFor="let location of locationList" [value]="location.value">
                {{ location.label }}
              </mat-option>
            </mat-select>
        </mat-form-field> -->
      </div>
    </div>
    <div fxLayoutAlign.xs="center center" fxFlex="50" fxFlex.xs="100" fxFlex.gt-sm="100">
      <mat-paginator #paginator [length]="total" [pageSizeOptions]="pageSizeOptions"
      (page)="onPage($event)"
      [pageSize]="100" [pageIndex]="currentPage">
      </mat-paginator>
    </div>
  </mat-card>
  <mat-table [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
    <ng-container matColumnDef="checkbox">
      <mat-header-cell *matHeaderCellDef>
        <mat-checkbox #masterCheckbox [checked]="selection.hasValue() && isChecked == true"
          (change)="$event ? toggleAllRows() : null" (click)="$event.stopPropagation()"
          [indeterminate]="selection.hasValue() && isAllSelected()"> </mat-checkbox>
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="table__checkbox" (click)="onCheckboxToggle(row, $event)">
        <mat-checkbox [checked]="selection.isSelected(row)" (click)="$event.stopPropagation()"
          (change)="$event ? onCheckboxToggleChild(row) : null">
        </mat-checkbox>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="invBatchName">
      <mat-header-cell *matHeaderCellDef mat-sort-header="invBatchName">
        {{ "name" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row">
        <span class="mobile-label">{{ "name" | translate }}:</span>
        <span>{{row.invBatchName}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="invStartTS">
      <mat-header-cell *matHeaderCellDef mat-sort-header="invStartTS" class="flex-header">
        {{ "countOpened" | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let row" class="flex-header">
        <span class="mobile-label">{{ "countOpened" | translate }}</span>
        {{ onMoment(row.invStartTS) }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="fullName">
      <mat-header-cell *matHeaderCellDef mat-sort-header class="flex-header">
        {{ "user" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="flex-header">
        <span class="mobile-label">{{ "user" | translate }}</span>
        <span>{{row.fullName }}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="total">
      <mat-header-cell *matHeaderCellDef mat-sort-header="total" class="flex-header">
        {{ "inventory.productsCounted" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="flex-header">
        <span class="mobile-label">{{ "inventory.productsCounted" | translate }}</span>
        <span>{{ row.total}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="unitTotal">
      <mat-header-cell *matHeaderCellDef mat-sort-header="unitTotal" class="flex-header">
        {{ "inventory.unitCounted" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="flex-header">
        <span class="mobile-label">{{ "inventory.unitCounted" | translate }}</span>
        <span>{{ row?.unitTotal?.replace(',', '')}}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="countedIn">
      <mat-header-cell *matHeaderCellDef mat-sort-header="invCloseTS" class="flex-header">
        {{ "countClosed" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" class="flex-header">
        <span class="mobile-label">{{ "countClosed" | translate }}</span>
        <span>{{ onMoment(row.countedIn) }}</span>
      </mat-cell>
    </ng-container>
    <div class="mat-row empty-row" *matNoDataRow fxLayout="row" fxLayoutAlign="center center">
      <p class="mat-cell" colspan="9999">
        <app-no-results key="inventory">
        </app-no-results>
      </p>
    </div>
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onRowClicked($event, row)">
    </mat-row>
  </mat-table>
</div>
<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x"
  [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu">
</div>
<mat-menu #contextMenu="matMenu">
  <ng-template matMenuContent class="menu">
    <span *ngFor="let r of rowMenuItems" [ngSwitch]="r">
      <button mat-menu-item *ngSwitchCase="'edit'" (click)="onEditEvent()">
        <mat-icon>visibility</mat-icon><span>{{ "viewEdit" | translate }}</span>
      </button>
      <button mat-menu-item *ngSwitchCase="'detail'" (click)="onDetailsEvent.emit(selectedRow);">
        <mat-icon>visibility</mat-icon><span>{{ "inventory.viewReport" | translate }}</span>
      </button>
      <button mat-menu-item *ngSwitchCase="'delete'" (click)="onDeleteEvent()">
        <mat-icon>delete</mat-icon><span>{{ "delete" | translate }}</span>
      </button>
    </span>
  </ng-template>
</mat-menu>
